import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@digdir/designsystemet-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/debug")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Table className="max-w-max rounded-md m-8" data-color="unbranded">
      <TableBody>
        <TableRow>
          <TableCell>
            <strong>App Version</strong>
          </TableCell>
          <TableCell>{__APP_VERSION__}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>Commit Hash</strong>
          </TableCell>
          <TableCell>{__COMMIT_HASH__}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
